import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'dateFormat',
    standalone: false
})
  export class DateFormatPipe extends DatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
      if(value && value!="" && value != "Invalid Date" ){
        return super.transform(value, Constants.DATE_FMT);
      }else{
        return "";
      }
      
    }
  }
  
  export class Constants {
    static readonly DATE_FMT = 'MM/dd/yyyy';
    static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
  }